import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@dixa/lib-shared-habla';
import FileSaver from 'file-saver';
import * as React from 'react';
import '../../styles/attachments-field.less';
import { ajaxSend } from '../../../../../../api/api';
import { getFileSize, isPreviewableAttachment, } from '../../../../../../app/utils/attachments';
class AttachmentsFieldList extends React.Component {
    constructor() {
        super(...arguments);
        this.fetchPrivateFileBlob = (url) => {
            return ajaxSend({
                path: url,
                responseType: 'blob',
            });
        };
        this.fetchPrivateFile = (fileName, url) => {
            this.fetchPrivateFileBlob(url)
                .then((blob) => {
                FileSaver.saveAs(blob, decodeURIComponent(fileName.split('/').pop()));
            })
                .catch((e) => {
                console.error(e);
            });
        };
        this.previewPrivateFile = (fileName, url) => {
            const { previewImage } = this.props;
            this.fetchPrivateFileBlob(url)
                .then((blob) => window.URL.createObjectURL(blob))
                .then((blobUrl) => {
                previewImage({ fileName, url: blobUrl });
            })
                .catch((e) => {
                console.error(e);
            });
        };
    }
    render() {
        const { fields } = this.props;
        const attachments = fields.map((f, i) => fields.get(i));
        return (_jsx("div", Object.assign({ className: `attachments-field-list ` }, { children: attachments.length > 0 && (_jsxs(React.Fragment, { children: [_jsx("div", Object.assign({ className: "file-header" }, { children: "Attached file(s)" })), _jsx("ul", Object.assign({ className: "file-list" }, { children: fields.map((field, index) => (_jsxs("li", Object.assign({ className: "file-item" }, { children: [_jsxs("p", Object.assign({ className: "file-text" }, { children: [_jsx("span", Object.assign({ className: "file-name" }, { children: fields.get(index).name })), !!fields.get(index).size && (_jsx("span", Object.assign({ className: "file-size" }, { children: `[${getFileSize(fields.get(index).size)}]` })))] })), _jsxs("div", Object.assign({ className: "file-item__actions" }, { children: [isPreviewableAttachment(fields.get(index).name) && (_jsx(IconButton, { className: "file-item__action", variant: "tertiary", icon: "eye", onClick: () => this.previewPrivateFile(fields.get(index).name, fields.get(index).absolute_uri) })), !!fields.get(index).absolute_uri && (_jsx(IconButton, { className: "file-item__action", variant: "tertiary", icon: "download", onClick: () => this.fetchPrivateFile(fields.get(index).name, fields.get(index).absolute_uri) })), _jsx(IconButton, { className: "file-item__action", onClick: (event) => {
                                                event.stopPropagation();
                                                fields.remove(index);
                                            }, variant: "tertiary", icon: "trash" })] }))] }), index))) }))] })) })));
    }
}
export default AttachmentsFieldList;
